import React, { Component } from 'react'
import './index.css'
import { Alert as BootstrapAlert } from 'react-bootstrap'

export default class Alert extends Component {
  constructor(props) {
    super(props);

    this.hideElement = this.hideElement.bind(this);
    this.getByVariant = this.getByVariant.bind(this);
    this.onDismiss = this.onDismiss.bind(this);

    this.state = {
      showAlert: true,
      variantStyle: this.getByVariant()[props.variant || 'warning'],
    };
  }

  getByVariant() {
    return {
      'warning': {icon: 'info-circle', variant: 'warning', iconFontSize: '1.5rem', iconColor: '#ECCC62'},
      'error': {icon: 'info-circle', variant: 'danger', iconFontSize: '1.5rem', iconColor: ''},
      'success': {icon: 'check-circle', variant: 'success', iconFontSize: '2rem', iconColor: ''},
    }
  }

  onDismiss() {
    this.props.onDismiss ? this.props.onDismiss() : this.hideElement();
  }

  hideElement() {
    this.setState({ showAlert: false })
  }

  render() {
    return (
      <div className={`alert-component ${this.state.showAlert ? '' : 'hidden'}`}>
        <BootstrapAlert bsStyle={this.state.variantStyle['variant']} onDismiss={this.onDismiss}>
          <div className="alert-component__body">
            <div className="alert-component__body__icon">
              <i
                className={`fa fa-${this.state.variantStyle['icon']}`}
                style={{color: this.state.variantStyle['iconColor'], fontSize: this.state.variantStyle['iconFontSize']}}
              />
            </div>
            <div className="alert-component__body__content">
              <div className="alert-component__body__content__title">{this.props.title}</div>
              <div className="alert-component__body__content__message">{this.props.children}</div>
            </div>
          </div>
        </BootstrapAlert>
      </div>
    )
  }
}

